/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {useFocusEffect, useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useCallback, useEffect, useRef, useState} from 'react';
import {
  Dimensions,
  Image,
  Platform,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import {connect} from 'react-redux';
import {compressFile} from '../../../common/utils/compression/index.web';
import {initProfilDTO, profilDTO} from '../../../data/constants/profil';
import {IRequiredFields} from '../../../data/types/interface/profil';
import {StackParams} from '../../../data/types/navigation';
import {ImageServices} from '../../../services/applicatif/image';
import {mapDispatchToProps} from '../../../services/redux/actions';
import {
  dispatchInscriptionUser,
  dispatchSignOutUser,
} from '../../../services/redux/dispatch';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import store from '../../../services/redux/store';
import {putFormData} from '../../../services/technique/api';
import {buttonsStyles} from '../../components/Button/boutonStyle';
import PrimaryButton from '../../components/Button/PrimaryButton';
import {HeaderScreen} from '../../components/Header/HeaderScreen';
import {FilePickerWeb} from '../../components/Inputs/FilePicker/FilePickerWeb';
import {formsStyles} from '../../components/Inputs/formStyles';
import Input from '../../components/Inputs/Input';
import {InputImage} from '../../components/Inputs/InputImage';
import {InputPhoneNumber} from '../../components/Inputs/InputPhoneNumber/index.web';
import Label from '../../components/Label';
import {Loader} from '../../components/Loader';
import ConfirmationModal from '../../components/Modal/ConfirmationModal';
import {DeleteAccount} from './DeleteAccount';
import styles from './styles';

type NavigationProps = StackNavigationProp<StackParams, 'MonProfil'>;

let isImageOk: boolean = true;
const MonProfilScreen = (props: any) => {
  const {user, route} = props;

  const [cinUser, setCinUser] = useState<any>({
    cin: [],
  });

  const defaultValue = route.params || {};

  const [isEditView, setIsEditView] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [editProfilDto, setEditProfilDto] = useState<any>(
    Object.keys(defaultValue) ? defaultValue : profilDTO,
  );
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [cinMessage, setCinMessage] = useState('Non renseigné');
  const [RequiredFields, setRequiredFields] =
    React.useState<IRequiredFields>(initProfilDTO);
  const imageServices = ImageServices();

  useFocusEffect(
    useCallback(() => {
      if (
        Object.keys((store.getState() as any).user?.data ?? {})?.length == 0
      ) {
        const {image, ...rest} = editProfilDto;
        navigate('Login', {data: 'MonProfil', params: {...rest}});
      }
    }, [(store.getState() as any).user]),
  );

  const updateCin = (utilisateur: any) => {
    const images = [];
    let isCinOK = true;

    if (utilisateur.cinUrl1) {
      images.push({
        name: utilisateur.cinUrl1,
        path: utilisateur.cinUrl1,
        type: 'image/png',
        uri: utilisateur.cinUrl1,
      });
    }
    if (utilisateur.cinUrl2) {
      images.push({
        name: utilisateur.cinUrl2,
        path: utilisateur.cinUrl2,
        type: 'image/png',
        uri: utilisateur.cinUrl2,
      });
    }

    if (utilisateur.cinUrl1 !== null) {
    } else {
      isCinOK = false;
    }
    if (utilisateur.cinUrl2 !== null) {
    } else {
      isCinOK = false;
    }

    isCinOK && setCinMessage('Renseigné');
    setCinUser({...cinUser, cin: images});
  };

  useEffect(() => {
    if (Object.keys(defaultValue).length == 0) {
      if (user && user.data && user.data.utilisateur) {
        setEditProfilDto({
          nom: user.data.utilisateur.nom,
          prenom: user.data.utilisateur.prenom,
          countryCode: user.data.utilisateur.countryCode,
          countryCode2: user.data.utilisateur.second_country_code || 'MG',
          telephone: user.data.utilisateur.telephone,
          telephone2: user.data.utilisateur.second_phone || undefined,
          email: user.data.utilisateur.email,
          ville: user.data.utilisateur.ville,
          adresse: user.data.utilisateur.adresse,
          image: user.data.utilisateur.imageUrl,
          id: user.data.utilisateur.id,
        });
      }
    } else {
      setIsEditView(true);
    }
    if (user?.data?.utilisateur) {
      updateCin(user.data.utilisateur);
      imageServices
        .getUtilisateurImage(user.data.utilisateur.imageUrl)
        .then(res => {
          setPicture(res);
        });
    }
  }, [user && user.data && user.data.utilisateur]);

  const [picture, setPicture] = useState<any>({
    uri:
      typeof editProfilDto.image == 'string'
        ? editProfilDto.image
        : user?.data?.utilisateur?.imageUrl || '',
  });
  const userConnected = useRef(false);
  const {navigate} = useNavigation<NavigationProps>();
  const windowHeight = Dimensions.get('window').height;
  const nom = '';

  const editView = () => {
    setIsEditView(true);
  };
  const saveView = () => {
    editProfile();
  };
  const handleLogout = () => {
    dispatchSignOutUser();
    navigate('Home');
  };

  const handleChange = (
    name: string,
    value: any,
    fired: boolean,
    remove?: boolean,
  ) => {
    const _value = value;

    if (remove) {
      setCinUser({...cinUser, cin: _value});
    } else {
      const images = [...cinUser.cin];
      images.push(_value);
      setCinUser({...cinUser, cin: images});
    }
  };

  const editProfile = () => {
    setIsLoading(true);
    if (isImageOk) {
      formDataDTO().then(data => {
        putFormData('auth/utilisateur/profil', data).then(response => {
          setIsLoading(false);

          if (response && response.data && response.data.data) {
            dispatchInscriptionUser(response.data);
            setIsEditView(false);
            navigate('MonProfil');
          } else {
            response && response.message && setErrorMessage(response.message);
          }
        });
      });
    } else {
      RequiredFields.image = true;
      setIsLoading(false);
    }
  };

  const callback = (name: string, value: string) => {
    setEditProfilDto({...editProfilDto, [name]: value});
  };

  const handleFile = (files: any) => {
    let extension = '';
    if (files.length > 0) {
      extension = files[0].name.split('.')[1].toLowerCase();

      if (
        extension !== 'jpg' &&
        extension !== 'svg' &&
        extension !== 'png' &&
        extension !== 'jpeg'
      ) {
        RequiredFields.image = true;
        isImageOk = false;
        setEditProfilDto({...editProfilDto, image: ''});
      } else {
        isImageOk = true;
        setPicture(URL.createObjectURL(files[0]));
        RequiredFields.image = editProfilDto != null;
        setEditProfilDto({...editProfilDto, image: files[0]});
      }
    } else {
      RequiredFields.image = true;
      isImageOk = false;
      setEditProfilDto({...editProfilDto, image: ''});
    }
  };

  const formDataDTO = async () => {
    const formData = new FormData();
    formData.append('id', editProfilDto.id.toString());
    formData.append('telephone', editProfilDto.telephone);
    if (Boolean(editProfilDto.telephone2)) {
      formData.append('second_phone', editProfilDto.telephone2);
    } else {
      formData.append('second_phone', '');
    }
    formData.append('countryCode', editProfilDto.countryCode);
    formData.append('second_country_code', editProfilDto.countryCode2);
    formData.append('email', editProfilDto.email);
    formData.append('ville', editProfilDto.ville);
    formData.append('adresse', editProfilDto.adresse);

    // console.log(editProfilDto);
    console.log(editProfilDto.image);
    if (typeof editProfilDto.image === 'object') {
      const compressedFile = await compressFile(editProfilDto.image);
      formData.append('image', compressedFile);
    } else if (typeof editProfilDto.image == 'string') {
      formData.append('image', editProfilDto.image);
    }

    cinUser.cin.length > 0 &&
      cinUser.cin.forEach((elt: any) => {
        formData.append('cin', elt);
      });
    return formData;
  };

  return (
    <View>
      <HeaderScreen
        type="GoToMonEspace"
        title="Compte > Profil"
        noBreadcrumb={false}
      />
      {isLoading ? (
        <View style={{marginTop: '15%'}}>
          <Loader />
        </View>
      ) : (
        <ScrollView>
          <View style={[formsStyles.webformContain]}>
            <View
              style={[
                formsStyles.formContainP,
                {
                  justifyContent: 'flex-start',
                  minHeight: windowHeight - 80,
                  backgroundColor: '#fff',
                },
              ]}>
              <View style={{alignItems: 'center'}}>
                {errorMessage !== '' && (
                  <ConfirmationModal
                    title="Erreur"
                    content={errorMessage}
                    btn1="OK"
                    handleBtn1={() => {
                      setErrorMessage('');
                    }}
                  />
                )}
                <View style={styles.profilHead}>
                  <View style={styles.Headevide}></View>
                  <View style={styles.ProfilImageCenter}>
                    {isImageOk !== true ? (
                      <Image
                        source={require('../../../ressources/images/user_ph.png')}
                        style={formsStyles.profilInsc}
                      />
                    ) : (
                      <Image style={styles.ProfilImage} source={picture} />
                    )}
                    <View>
                      {Platform.OS === 'web' && isEditView && (
                        <View>
                          <TouchableOpacity>
                            <FilePickerWeb
                              callback={handleFile}
                              type={true ? 'fileLabeledNotext' : 'fileLabeled'}
                            />
                          </TouchableOpacity>
                          {isImageOk === false && (
                            <Text style={styles.textError}>
                              Veuillez vérifier le format de votre fichier
                            </Text>
                          )}
                        </View>
                      )}
                    </View>
                  </View>

                  {/** Icon edit profile */}
                  {isEditView && <View style={styles.Headevide}></View>}
                </View>

                <Label title={nom} type="titleGreen" />
              </View>
              <View
                style={[
                  {
                    alignItems: 'center',
                    zIndex: 1000,
                    flexDirection: 'column',
                    flex: 2,
                  },
                ]}>
                {isEditView ? (
                  <InputPhoneNumber
                    label="Téléphone"
                    required
                    name="telephone"
                    type="inputEditable"
                    value={editProfilDto.telephone}
                    onChange={(name: string, value: string) =>
                      callback(name, value)
                    }
                    isEditable={isEditView}
                    showError
                    country={editProfilDto.countryCode}
                    onChangeCountry={(country: string) =>
                      callback('countryCode', country)
                    }
                    style={{width: 300}}
                  />
                ) : (
                  <InputPhoneNumber
                    label="Téléphone"
                    required
                    name="telephone"
                    type="inputEditable"
                    value={editProfilDto.telephone}
                    onChange={(value: string) =>
                      console.log('telephone', value)
                    }
                    isEditable={false}
                    showError
                    country={editProfilDto.countryCode}
                    onChangeCountry={(country: string) =>
                      console.log('countryCode', country)
                    }
                    style={{width: 300}}
                  />
                )}
                {isEditView ? (
                  <InputPhoneNumber
                    label="2ème Téléphone"
                    name="telephone2"
                    type="inputEditable"
                    value={editProfilDto.telephone2}
                    onChange={(name: string, value: string) => {
                      console.log(name, value);

                      callback(name, value);
                    }}
                    isEditable={isEditView}
                    showError={!!editProfilDto.telephone2}
                    country={editProfilDto.countryCode2}
                    onChangeCountry={(country: string) =>
                      callback('countryCode2', country)
                    }
                    style={{width: 300}}
                  />
                ) : editProfilDto.telephone2 ? (
                  <InputPhoneNumber
                    label="2ème Téléphone"
                    name="telephone2"
                    type="inputEditable"
                    value={editProfilDto.telephone2}
                    onChange={(value: string) =>
                      console.log('telephone2', value)
                    }
                    isEditable={false}
                    showError={!!editProfilDto.telephone2}
                    country={editProfilDto.countryCode2}
                    onChangeCountry={(country: string) =>
                      console.log('countryCode2', country)
                    }
                    style={{width: 300}}
                  />
                ) : null}
                <Input
                  type="inputEditable"
                  label={`Mail`}
                  name="email"
                  parentCallback={(value: string) => callback('email', value)}
                  required
                  defaultValue={editProfilDto.email}
                  isEditable={false}
                />
                <Input
                  type="inputEditable"
                  label="Ville"
                  name="ville"
                  parentCallback={(value: string) => callback('ville', value)}
                  required
                  defaultValue={editProfilDto.ville}
                  isEditable={isEditView}
                />
                <Input
                  type="inputEditable"
                  label="Adresse"
                  name="adresse"
                  parentCallback={(value: string) => callback('adresse', value)}
                  required
                  defaultValue={editProfilDto.adresse}
                  isEditable={isEditView}
                />
                {isEditView ? (
                  <View style={{width: 310}}>
                    <InputImage
                      label={'CIN (recto, verso)'}
                      name="cinUser"
                      value={cinUser.cin}
                      onChange={handleChange}
                      error={''}
                      showError={false}
                      maxLength={2}
                    />
                  </View>
                ) : (
                  <View style={[{width: 300, marginLeft: 4}]}>
                    <Text style={formsStyles.labelStyle}>
                      CIN: {cinMessage}
                    </Text>
                  </View>
                )}
                {isEditView ? (
                  <View style={styles.btnContainerProfilP}>
                    <PrimaryButton
                      onPress={() => {
                        setIsEditView(false);
                      }}
                      styleBtnTxt={buttonsStyles.btnAnnuler}
                      styleBtnOuter={buttonsStyles.btnAnnulerOuter}
                      title="Annuler"
                      type="annuler"
                    />
                    <PrimaryButton
                      onPress={() => {
                        saveView();
                      }}
                      styleBtnTxt={buttonsStyles.btnValider}
                      styleBtnOuter={buttonsStyles.btnValiderOuter}
                      title="Enregistrer"
                      type="valider"
                    />
                  </View>
                ) : (
                  <View style={[buttonsStyles.displayCenterP]}>
                    <PrimaryButton
                      onPress={() => {
                        editView();
                      }}
                      styleBtnTxt={buttonsStyles.btnValider}
                      styleBtnOuter={buttonsStyles.btnValiderOuterProfil}
                      title="Modifier mes informations"
                      type="valider"
                    />
                    {Dimensions.get('window').width < 720 && (
                      <PrimaryButton
                        onPress={() => {
                          handleLogout();
                        }}
                        styleBtnTxt={buttonsStyles.btnAnnuler}
                        styleBtnOuter={[
                          buttonsStyles.btnAnnulerOuter,
                          {
                            width: 300,
                          },
                        ]}
                        title="Déconnexion"
                        type="valider"
                      />
                    )}

                    <TouchableOpacity
                      onPress={() => setShowDelete(true)}
                      style={{alignItems: 'center', marginTop: 10}}>
                      <Label title="Supprimer mon compte" type="titleGreen11" />
                    </TouchableOpacity>
                  </View>
                )}
              </View>
              {showDelete ? (
                <DeleteAccount
                  onClose={() => setShowDelete(false)}
                  logout={handleLogout}
                />
              ) : null}
            </View>
          </View>
        </ScrollView>
      )}
    </View>
  );
};
export const MonProfil: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MonProfilScreen);
